import { useRef } from 'react';
import { BarberSkeleton } from '../Interface/Skeleton';
import './Barbeiros.css';

const Barbeiros = ({ onSelectBarber, barbers = [], error, loading }) => {
    const scrollContainerRef = useRef(null);

    const scroll = (direction) => {
        if (scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            const card = container.querySelector('.barber-card') || container.querySelector('.barber-skeleton');
            const scrollAmount = card ? card.offsetWidth + 20 : 300;

            container.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    return (
        <section className="barbers-section" id="barbeiros">
            <h2 className="section-title">AGENDE SEU HORÁRIO</h2>
            <p className="section-subtitle">Escolha um profissional abaixo para continuar</p>

            <div className="barbers-carousel-container">
                <button className="carousel-arrow left" onClick={() => scroll('left')} aria-label="Anterior">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>

                <div className="barbers-scroll-wrapper" ref={scrollContainerRef}>
                    {loading ? (
                        <div className="barbers-loading-grid">
                            {[...Array(3)].map((_, i) => <BarberSkeleton key={i} />)}
                        </div>
                    ) : barbers.length > 0 ? (
                        barbers.map((barber) => (
                            <div
                                key={barber.id}
                                className="barber-card"
                                onClick={() => onSelectBarber(barber)}
                            >
                                <div className="barber-image-container">
                                    <img src={barber.image} alt={barber.name} className="barber-image" loading="lazy" />
                                </div>
                                <div className="barber-info">
                                    <h3 className="barber-name">{barber.name}</h3>
                                    <button
                                        className="book-button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onSelectBarber(barber);
                                        }}
                                    >
                                        AGENDAR
                                    </button>
                                </div>
                            </div>
                        ))
                    ) : error ? (
                        <div className="no-barbers-msg">
                            <p>Nenhum profissional disponível no momento.</p>
                            <div style={{
                                color: '#ff4d4d',
                                marginTop: '15px',
                                fontSize: '0.85rem',
                                padding: '15px',
                                background: 'rgba(255,0,0,0.15)',
                                borderRadius: '8px',
                                border: '1px solid rgba(255,0,0,0.3)',
                                textAlign: 'center'
                            }}>
                                ⚠️ <b>PROBLEMA DE CONEXÃO:</b> <br />
                                <code style={{ background: 'rgba(0,0,0,0.3)', padding: '2px 5px', borderRadius: '4px', marginTop: '5px', display: 'inline-block' }}>{error}</code>
                                <p style={{ marginTop: '10px', fontSize: '0.75rem', color: '#ccc' }}>
                                    Se você é o dono, verifique a aba <b>Rules</b> no Console do Firebase.
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div className="no-barbers-msg">
                            <p>Nenhum profissional disponível no momento.</p>
                            <p style={{ fontSize: '0.8rem', opacity: 0.6 }}>O dono da barbearia ainda não cadastrou profissionais.</p>
                        </div>
                    )}
                </div>

                <button className="carousel-arrow right" onClick={() => scroll('right')} aria-label="Próximo">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </div>
        </section>
    );
};

export default Barbeiros;
